import { hitEvent } from '../hitEvent';
export var triggerTns = function triggerTns(options) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (debug) {
    window.console.info('TNS options', options);
    return;
  }

  hitEvent(options.src);
};